import { store } from '@sonifi/wb-core/store/store';
import { redirect } from 'react-router';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { initIrdMenu } from '../MenuBuilder/services/irdMenu.service';
import { checkRevenueCenter } from '../Settings/services/irdSettings.service';
import { setNodePreviewSelected } from '../store/menu/irdMenuSlice';
import { getInicialNode } from '../MenuBuilder/services/helpers/irdMenuHelper';
import { ROUTES_PATH } from '@sonifi/wb-core/routes/routesConstants';

export async function loaderIrdMenuBuilder({ params }) {
  const { groupId, platform, id } = params;
  const groupIdInt = parseInt(groupId);
  const {
    irdSettings: { revenueCenterSelected },
  } = store.getState();

  const revenueCenter = await store.dispatch(
    checkRevenueCenter({ groupId: groupIdInt, revenueCenterSelected }),
  );

  const nodeId = await store.dispatch(
    initIrdMenu({
      groupId: groupIdInt,
      id,
      platform,
      revenueCenter,
    }),
  );

  if (nodeId) {
    return redirect(nodeId);
  }

  return {};
}

export async function loaderIrdMenuBuilderNodeId({ params }) {
  const { groupId, platform, id } = params;
  const {
    irdMenu: { loadingIrdMenu, irdMenu, nodeMenuSelected },
    irdSettings: { revenueCenterSelected },
  } = store.getState();

  if (loadingIrdMenu !== LOADING_STATUS.success) {
    const revenueCenter = await store.dispatch(
      checkRevenueCenter({ groupId: parseInt(groupId), revenueCenterSelected }),
    );
    // Redirect because IRD Nodes id are dynamic and created on the fly
    return redirect(
      `${ROUTES_PATH.PRODUCTS.PATH}/${groupId}/in_room_dining/${revenueCenter?.id}/menu/${platform}`,
    );
  } else if (nodeMenuSelected?.id !== id) {
    const node = getInicialNode({ id, menu: irdMenu.menu });
    store.dispatch(setNodePreviewSelected({ node }));
  }

  return {};
}
